export default __webpack_public_path__ + "static/char-s-33-en-c26320872699e500af3436f3c4d8be09.png";